/* global PagefindUI */
import MicroModal from 'micromodal';

const {KitModule, registerModule} = window;

class Search extends KitModule {
  constructor($element) {
    super($element);

    this.initialize();
  }

  bindEvents() {
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  handleKeyDown(event) {
    if (event.key === 'k' && event.metaKey) {
      // Toggle visibility of modal
      event.preventDefault();
      if (this.$searchModal.getAttribute('aria-hidden') === 'true') {
        MicroModal.show('modal-search');
      } else {
        MicroModal.close('modal-search');
      }
    }
  }

  initialize() {
    this.setVars();
    this.bindEvents();

    // Modal markup is defined in a template to prevent it from being rendered
    // or parsed if JavaScript isn't enabled, and needs to be added to the DOM
    if (this.$modalTemplate) {
      const $searchModal = document.querySelector('#modal-search');

      if (!$searchModal) {
        // The template hasn't been cloned yet, so let's do it now.
        const clone = this.$modalTemplate.content.cloneNode(true);
        document.body.appendChild(clone);
      }

      this.$searchModal = document.querySelector('#modal-search');
    }

    MicroModal.init({
      disableScroll: true,
    });

    // Load Pagefind
    new PagefindUI({
      debounceTimeoutMs: 500,
      element: '#search',
    });

    // The module is hidden while data-js-initialized == "false" to prevent it
    // from being shown if JavaScript isn't enabled.
    this.$element.dataset.jsInitialized = true;
  }

  setVars() {
    this.pageFind;
  }

  unmount() {
    //
  }
}

registerModule('Search', Search);
